const visionPageDataAr = {
    title : "رؤية السعودية 2030",
    sectionOne : {
        paragraphOne : "تم إطلاق رؤية السعودية 2030 في عام 2016، وهي بمثابة خارطة طريق تحدد الأهداف التنموية المستقبلية للبلاد. تقوم هذه الرؤية على ثلاثة محاور رئيسية هي: مجتمع حيوي، اقتصاد مزدهر، وطن طموح. وتركز الرؤية على مبدأ الاستدامة، وتؤدي إلى تحقيق دورة مستمرة ومتجددة من التحولات الإيجابية. ويساهم بنك الأول في تحقيق مستهدفات برنامج التحول الرقمي الذي تضمنته الرؤية والاستفادة منه.",
        paragraphTwo : "توفر أهداف الأمم المتحدة للتنمية المستدامة إطارًا دوليًا يهدف إلى تعزيز الاقتصاد العالمي مع الحفاظ على البيئة وحماية الإنسان. وضمن مساعيه لتنفيذ الأهداف المحددة ضمن السعودية 2030، يساهم بنك الأول أيضا في تحقيق العديد من أهداف التنمية المستدامة للأمم المتحدة.",
    }
};
    

export default visionPageDataAr;